import React from 'react';
import { useApp } from '../context/AppContext';

const Home = () => {
  const { products, loading } = useApp();

  return (
    <div className="p-4">
      <h1 className="text-2xl font-black mb-6 text-white">
        {loading ? "Chargement..." : `${products.length} ARTICLES SOUVERAINS`}
      </h1>
      
      <div className="grid gap-4">
        {products.map((p, i) => (
          <div key={i} className="bg-white/5 border border-white/10 p-5 rounded-3xl flex justify-between items-center">
            <div>
              <h3 className="font-bold text-white text-lg">{p.name}</h3>
              <p className="text-white/40 text-xs uppercase tracking-widest">{p.category} • {p.store}</p>
            </div>
            <div className="text-right">
              <span className="text-2xl font-black text-[#10b981]">{p.price}€</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
